import { useState, useEffect } from 'react';

export const useProductInputs = (obj, userName) => {
  // GUARANTEED SAFE OBJECT
  const safeObj = obj || {};
  const safeProduct = safeObj.product || { product_type: '', type_img: '' };
  const safeDimensions = safeObj.dimensions || { long: '', short: '', width: '' };
  const safeReserved = safeObj.reserved || { isReserved: false, id: '' };

  const [inputs, setInputs] = useState({
    product: {
      product_type: safeProduct.product_type || '',
      type_img: safeProduct.type_img || '',
    },
    length: safeDimensions.long || '',
    height: safeDimensions.short || '',
    width: safeDimensions.width || '',
    location: safeObj.warehouse_location || '',
    editedBy: userName || '',
    comments: safeObj.comments || '',
    reserved: safeReserved.isReserved || false,
    defect: safeObj.defect || false,
    reserveId: safeReserved.id || '',
    productImg: safeObj.product_img || '',
  });

  // 🔥🔥 FIX: Update form when real product arrives
  useEffect(() => {
    const freshObj = obj || {};
    const freshProduct = freshObj.product || { product_type: '', type_img: '' };
    const freshDimensions = freshObj.dimensions || { long: '', short: '', width: '' };
    const freshReserved = freshObj.reserved || { isReserved: false, id: '' };

    setInputs({
      product: {
        product_type: freshProduct.product_type || '',
        type_img: freshProduct.type_img || '',
      },
      length: freshDimensions.long || '',
      height: freshDimensions.short || '',
      width: freshDimensions.width || '',
      location: freshObj.warehouse_location || '',
      editedBy: userName || '',
      comments: freshObj.comments || '',
      reserved: freshReserved.isReserved || false,
      defect: freshObj.defect || false,
      reserveId: freshReserved.id || '',
      productImg: freshObj.product_img || '',
    });
  }, [obj, userName]);

  // ... keep the rest of your hook functions exactly as they are
  const inputHandler = (e) => {
    if (e.target.id === 'reserved') {
      setInputs({
        ...inputs,
        reserved: !inputs.reserved,
        reserveId: inputs.reserved ? inputs.reserveId : '',
      });
      return;
    }
    if (e.target.id === 'warehouse_location') {
      setInputs({
        ...inputs,
        location: e.target.value,
      });
      return;
    }

    if (e.target.id === 'defect') {
      setInputs({
        ...inputs,
        defect: !inputs.defect,
      });
      return;
    }
    setInputs({
      ...inputs,
      [e.target.id]: e.target.value,
    });
  };

  const selectHandler = (e) => {
    const idx = e.target.selectedIndex;
    const el = e.target.childNodes[idx];
    const imgAttr = el.getAttribute('imgsrc');

    setInputs({
      ...inputs,
      product: {
        product_type: e.target.value,
        type_img: imgAttr,
      },
    });
  };

  const imageUploadInputHandler = (arr) => {
    setInputs({
      ...inputs,
      productImg: JSON.stringify(arr),
    });
  };

  return {
    inputs,
    inputHandler,
    selectHandler,
    imageUploadInputHandler,
  };
};
